<template>
  <transition-group
    tag="div"
    class="s-alert-container"
    enter-class="s-alert-container--enter"
    leave-to-class="s-alert-container--leave-to"
    leave-active-class="s-alert-container--leave-active"
  >
    <Alert
      v-for="(alert, index) in alertState.alerts"
      :key="alert.id"
      :alert="alert"
      :duration="alert.duration"
      @expired="removeAlert(index)"
      @dismissed="removeAlert(index)"
      @action="executeAction(alert, index)"
    ></Alert>
  </transition-group>
</template>

<script>
import useAlertManager from '@/platform/composables/useAlertManager';
import Alert from '@/platform/components/Alert';

export default {
  components: {
    Alert,
  },
  setup() {
    const { alertState, removeAlert } = useAlertManager();
    /**
     * execute alert action function and remove the alert
     *
     * @param alert
     * @param index
     */
    function executeAction(alert, index) {
      alert.action.fn();
      removeAlert(index);
    }
    return {
      alertState,
      removeAlert,
      executeAction,
    };
  },
};
</script>

<style lang="scss">
.s-alert-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  position: fixed;
  width: 400px;
  bottom: 30px;
  right: 20px;
  z-index: 1090;
}
.s-alert-container--enter,
.s-alert-container--leave-to {
  transform: translateX(150%);
}
.s-alert-container--leave-active {
  position: absolute;
}
</style>
